module.exports = __webpack_public_path__ + "static/GalanoGrotesque-Light-020fd578df72567ef7857b5647b73882.woff";